<template>
    <b-dropdown
        class="lx-responsive-dropdown mr-1"
        :id="responsiveDropdownId"
        :disabled="disabled"
        :variant="variant"
        tabindex="0"
        @show="handleDropdownShow"
        @hide="handleDropdownHide"
        :no-caret="noCaret"
        :dropleft="dropleft"
    >
        <template v-slot:button-content>
            <font-awesome-icon :icon="icon" size="lg" v-if="icon"></font-awesome-icon>
            <span
                v-if="!noLabel"
                :class="{
                    'lx-responsive-dropdown-label': true,
                    'lx-responsive-dropdown-label--responsiveness': !!icon & !!responsiveness,
                    'ml-2': !!icon,
                }"
            >
                <slot></slot>
            </span>
        </template>
        <template v-for="(item, index) in dropdownItems">
            <header class="dropdown-header item-header" v-if="item.sectionLabel">{{ item.sectionLabel }}</header>
            <b-dropdown-item
                v-else-if="item.condition === undefined || item.condition"
                :key="'lx-responsive-dropdown-item-' + index"
                :active="!!item.active"
                @click="item.click ? item.click() : (() => {})()"
                v-b-modal="item.modal"
                :disabled="item.disabled || false"
                :class="item.dropDownItemClass"
            >
                <font-awesome-icon
                    :icon="item.icon"
                    :size="item.iconSize ? item.iconSize : 'lg'"
                    v-if="item.icon"
                ></font-awesome-icon>
                <div v-if="item.customHTML" v-html="item.customHTML"></div>
                <span class="ml-1">{{ item.label }}</span>
            </b-dropdown-item>
        </template>

        <b-tooltip
            v-if="tooltip"
            triggers="click blur"
            :target="responsiveDropdownId"
            :variant="tooltipVariant"
            container="vue-app"
        >
            {{ tooltip }}
        </b-tooltip>
    </b-dropdown>
</template>

<script>
    export default {
        name: 'ResponsiveDropdown',
        props: {
            icon: [Object, Array, String],
            items: Array,
            disabled: {
                type: Boolean,
                default: false,
            },
            variant: {
                type: String,
                default: null,
            },
            tooltip: {
                type: String,
                default: null,
            },
            tooltipVariant: {
                type: String,
                default: null,
            },
            responsiveness: {
                type: Boolean,
                default: true,
            },
            noCaret: {
                type: Boolean,
                default: false,
            },
            noLabel: {
                type: Boolean,
                default: false,
            },
            dropleft: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            responsiveDropdownId() {
                return 'responsive-dropdown' + Math.random();
            },
            dropdownItems() {
                return this.items.filter((item) => item.condition === undefined || item.condition);
            },
        },
        methods: {
            handleDropdownShow(e) {
                this.$emit('show', e);
            },
            handleDropdownHide(e) {
                this.$emit('hide', e);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    :deep(.dropdown-toggle) {
        display: flex !important;
        align-items: center;
    }

    .lx-responsive-dropdown :deep(button) {
        user-select: none !important;
        box-shadow: none !important;
        display: flex !important;
        justify-content: left;
        align-items: center;
    }

    .lx-responsive-dropdown :deep(button:after) {
        display: inline-block;
        margin-left: 0.255em;
        vertical-align: 0.255em;
        content: '';
        border-top: 0.3em solid;
        border-right: 0.3em solid transparent;
        border-bottom: 0;
        border-left: 0.3em solid transparent;
    }
    
    .lx-responsive-dropdown {
        :deep(.dropdown-menu) {
            max-height: 80vh;
            overflow-y: auto;
            overflow-x: hidden;
        }
    }    

    .lx-responsive-dropdown-label {
        flex-basis: 100%;
        text-align: left;
    }

    @include media-breakpoint-down(md) {
        .lx-responsive-dropdown-label--responsiveness {
            display: none;
        }
        .lx-responsive-dropdown {
            height: 38px;
        }
    }

    .item-header {
        font-weight: bold;
        font-size: 1.1rem !important;
        padding: 0.5rem 1rem !important;
    }
</style>
